<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">

  <path d="m7.4826,4.40625L3.85955.7832c-.32812-.32812-.85938-.32812-1.1875,0s-.32812.85938,0,1.1875l3.0293,3.0293-3.0293,3.0293c-.32812.32812-.32812.85938,0,1.1875.16406.16406.37891.24609.59375.24609s.42969-.08203.59375-.24609l3.62305-3.62305c.32812-.32812.32812-.85938,0-1.1875Z" fill="var(--iconPrimary, #222)"/>
  
</svg>